<template>
  <div>
    <div class="confirmation-name">
      <h4 class="checkout-h4 confirmation-subtitle">
        Você pagou {{ totalValue | currency }}
      </h4>
      <div class="confirmation-name__icons">
        <h3
          class="checkout-h3"
          :class="
            status === 'S' || cardPaymentInfo.status === 'Em análise'
              ? 'orange--text'
              : 'success--text'
          "
        >
          {{
            status === 'S' || cardPaymentInfo.status === 'Em análise'
              ? 'Em Análise'
              : 'Aprovado'
          }}
        </h3>

        <svg
          class="alert-card__icon"
          v-if="status !== 'S' && cardPaymentInfo.status !== 'Em análise'"
          style="width:24px;height:24px"
          viewBox="0 0 24 24"
        >
          <path
            fill="#00a65a"
            d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
          />
        </svg>

        <v-icon class="alert-card__icon" v-else color="orange"
          >error_outline</v-icon
        >
      </div>
    </div>
    <p class="grey--text">
      {{ cardPaymentInfo.instalments }}{{ cardPaymentInfo.card }}
    </p>
    <div dark v-if="status === 'S'" class="alert-card">
      <v-icon class="alert-card__icon" color="error">error_outline</v-icon>
      <div style="color: white; margin: 0 16px;">
        Sua compra está em análise. Enviaremos uma confirmação por e-mail quando
        o status do seu pedido mudar
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    orderPdvData() {
      return this.$store.getters.orderPdvData;
    },
    partialValue() {
      return this.$store.getters.partialValue;
    },
    paymentData() {
      return this.$store.getters.paymentData;
    },
    eventID() {
      return this.$store.getters.eventID;
    },
    pendingOrder() {
      return this.$store.getters.pendingOrder;
    },
    cardPaymentInfo() {
      return this.$store.getters.postOrder;
    },

    itsPartialPayment() {
      if (
        this.$route.name !== 'commissioner' &&
        this.paymentData &&
        this.paymentData.split_payment &&
        this.productsTotal &&
        this.partialValue < this.productsTotal
      )
        return Number(this.productsTotal);
      if (
        this.$route.name === 'commissioner' &&
        this.orderPdvData &&
        this.orderPdvData.valor_pendente &&
        this.partialValue < Number(this.orderPdvData.valor_pendente)
      )
        return Number(this.orderPdvData.valor_pendente);
      return 0;
    },

    totalValue() {
      if (this.isCardPaymentOption && !this.itsPartialPayment)
        return this.productsTotal;
      if (this.pendingOrder || this.partialValue)
        return this.partialValue * 100;
      return this.productsTotal;
    },
    isCardPaymentOption() {
      return (
        this.$store.getters.paymentOption === 'CC' &&
        this.$store.getters.currentStep >= 4
      );
    },
    productsTotal() {
      if (this.isCardPaymentOption) {
        return this.$store.getters.totalAmount;
      }

      let total = 0;
      let somador = 0;
      this.cartProducts.forEach(p => {
        p.forEach(v => {
          somador += (v.valor + v.valor_conveniencia) * v.quantidade;
        });
      });
      total = somador;
      return total * 100;
    },
    cartProducts() {
      return this.$store.getters.cartProducts;
    },
    orderData() {
      return this.$store.getters.orderData;
    },
    status() {
      if (
        this.orderData &&
        this.orderData.orderData &&
        this.orderData.orderData.real_order_status
      )
        return this.orderData.orderData.real_order_status;
      else '';
    },
  },
};
</script>
